/* import __COLOCATED_TEMPLATE__ from './insert-hyperlink.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { cancel } from "@ember/runloop";
import { isEmpty } from "@ember/utils";
import { searchForTerm } from "discourse/lib/search";
import { prefixProtocol } from "discourse/lib/url";
import discourseDebounce from "discourse-common/lib/debounce";
import TEMPLATE from "./insert-hyperlink.hbs";
import { setComponentTemplate } from "@ember/component";
export default class InsertHyperlink extends Component {
  static #_ = (() => dt7948.g(this.prototype, "linkText", [tracked], function () {
    return this.args.model.linkText;
  }))();
  #linkText = (() => (dt7948.i(this, "linkText"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "linkUrl", [tracked], function () {
    return "";
  }))();
  #linkUrl = (() => (dt7948.i(this, "linkUrl"), void 0))();
  static #_3 = (() => dt7948.g(this.prototype, "selectedRow", [tracked], function () {
    return -1;
  }))();
  #selectedRow = (() => (dt7948.i(this, "selectedRow"), void 0))();
  static #_4 = (() => dt7948.g(this.prototype, "searchResults", [tracked], function () {
    return [];
  }))();
  #searchResults = (() => (dt7948.i(this, "searchResults"), void 0))();
  static #_5 = (() => dt7948.g(this.prototype, "searchLoading", [tracked], function () {
    return false;
  }))();
  #searchLoading = (() => (dt7948.i(this, "searchLoading"), void 0))();
  _debounced;
  _activeSearch;
  willDestroy() {
    super.willDestroy(...arguments);
    cancel(this._debounced);
  }
  highlightRow(e, direction) {
    const index = direction === "down" ? this.selectedRow + 1 : this.selectedRow - 1;
    if (index > -1 && index < this.searchResults.length) {
      document.querySelectorAll(".internal-link-results .search-link")[index].focus();
      this.selectedRow = index;
    } else {
      this.selectedRow = -1;
      document.querySelector("input.link-url").focus();
    }
    e.preventDefault();
  }
  selectLink(el) {
    this.searchResults = [];
    this.linkUrl = el.href;
    this.selectedRow = -1;
    if (!this.linkText && el.dataset.title) {
      this.linkText = el.dataset.title;
    }
    document.querySelector("input.link-text").focus();
  }
  async triggerSearch() {
    if (this.linkUrl.length < 4 || this.linkUrl.startsWith("http")) {
      this.abortSearch();
      return;
    }
    this.searchLoading = true;
    this._activeSearch = searchForTerm(this.linkUrl, {
      typeFilter: "topic"
    });
    try {
      const results = await this._activeSearch;
      this.searchResults = results?.topics || [];
    } finally {
      this.searchLoading = false;
      this._activeSearch = null;
    }
  }
  abortSearch() {
    this._activeSearch?.abort();
    this.searchResults = [];
    this.searchLoading = false;
  }
  keyDown(event) {
    switch (event.key) {
      case "ArrowDown":
        this.highlightRow(event, "down");
        break;
      case "ArrowUp":
        this.highlightRow(event, "up");
        break;
      case "Enter":
        // override Enter behavior when a row is selected
        if (this.selectedRow > -1) {
          const selected = document.querySelectorAll(".internal-link-results .search-link")[this.selectedRow];
          this.selectLink(selected);
          event.preventDefault();
          event.stopPropagation();
        }
        break;
      case "Escape":
        // Esc should cancel dropdown first
        if (this.searchResults.length) {
          this.searchResults = [];
          event.preventDefault();
          event.stopPropagation();
        } else {
          this.args.closeModal();
          document.querySelector(".d-editor-input")?.focus();
        }
        break;
    }
  }
  static #_6 = (() => dt7948.n(this.prototype, "keyDown", [action]))();
  mouseDown(event) {
    if (!event.target.closest(".inputs")) {
      this.searchResults = [];
    }
  }
  static #_7 = (() => dt7948.n(this.prototype, "mouseDown", [action]))();
  ok() {
    const origLink = this.linkUrl;
    const linkUrl = prefixProtocol(origLink);
    const sel = this.args.model.toolbarEvent.selected;
    if (isEmpty(linkUrl)) {
      return;
    }
    const linkText = this.linkText || "";
    if (linkText.length) {
      this.args.model.toolbarEvent.addText(`[${linkText}](${linkUrl})`);
    } else if (sel.value) {
      this.args.model.toolbarEvent.addText(`[${sel.value}](${linkUrl})`);
    } else {
      this.args.model.toolbarEvent.addText(`[${origLink}](${linkUrl})`);
      this.args.model.toolbarEvent.selectText(sel.start + 1, origLink.length);
    }
    this.args.closeModal();
  }
  static #_8 = (() => dt7948.n(this.prototype, "ok", [action]))();
  linkClick(e) {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      e.stopPropagation();
      this.selectLink(e.target.closest(".search-link"));
    }
  }
  static #_9 = (() => dt7948.n(this.prototype, "linkClick", [action]))();
  updateLinkText(event) {
    this.linkText = event.target.value;
  }
  static #_10 = (() => dt7948.n(this.prototype, "updateLinkText", [action]))();
  search(event) {
    this.linkUrl = event.target.value;
    this._debounced = discourseDebounce(this, this.triggerSearch, 400);
  }
  static #_11 = (() => dt7948.n(this.prototype, "search", [action]))();
}
setComponentTemplate(TEMPLATE, InsertHyperlink);